;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .controller('MicrosoftteamsCreateCtrl', MicrosoftteamsCreateCtrl)

  function MicrosoftteamsCreateCtrl(
    $scope,
    $location,
    logger,
    WebhookFactory,
    ErrorService,
    integrationService,
    UserService,
    NOTIFICATION_TYPE_OPTIONS,
    INTEGRATION_TYPE
  ) {
    'ngInject'
    angular.extend($scope, {
      adding: false,
      fieldErrors: [],
      model: {
        name: '',
        url: '',
        properties: {},
        all_applications: true,
        applications: [],
        type: INTEGRATION_TYPE.MICROSOFTTEAMS,
        valid: true
      },
      applicationsPromise: undefined,
      isEdit: false,
      showInvalidConnection: false,
      showValidConnection: false,
      select: {
        applications: [],
        channels: []
      },
      testing: false,
      isUrlTested: false,
      integrationPromise: undefined
    })

    angular.extend($scope, {
      saveIntegration: saveIntegration,
      addApplication: addApplication,
      removeApplication: removeApplication,
      cancelCreation: cancelCreation,
      deleteIntegration: deleteIntegration,
      testConnection: testConnection,
      resetConnection: resetConnection
    })

    function saveIntegration() {
      $scope.adding = true

      if ($scope.model.all_applications) {
        $scope.model.applications = []
      }

      WebhookFactory.addWebhook($scope.model).then(
        function (response) {
          logger.logSuccess(response.data.messages[0])
          $scope.adding = false
          $location.path(UserService.buildUrl('/settings/integration'), true)
        },
        function (response) {
          ErrorService.processError(response)
          $scope.adding = false

          if (response && response.data) {
            $scope.fieldErrors = response.data.errors
          }
        }
      )
    }

    function deleteIntegration(webhook) {
      integrationService.deleteIntegration(webhook)
    }

    function testConnection() {
      $scope.isUrlTested = true
      $scope.testing = true
      $scope.showValidConnection = false
      $scope.showInvalidConnection = false

      integrationService
        .testMicrosoftteamsConnection($scope.model.url)
        .then(
          function () {
            $scope.showValidConnection = true
          },
          function (response) {
            $scope.showInvalidConnection = true

            if (response && response.data) {
              $scope.fieldErrors = response.data.errors
            }
          }
        )
        .finally(function () {
          $scope.testing = false
        })
    }

    function addApplication(item, model) {
      integrationService.addApplication($scope, model)
    }

    function removeApplication(item, model) {
      integrationService.removeApplication($scope, model)
    }

    function cancelCreation() {
      $scope.model = { name: '', url: '', applications: [] }
      $scope.select = { applications: [] }
      $location.path(UserService.buildUrl('/settings/integration'), true)
    }

    function resetConnection() {
      $scope.showValidConnection = false
      $scope.showInvalidConnection = false
      $scope.isUrlTested = false
    }

    function init() {
      $scope.applicationsPromise = integrationService
        .getApplications($scope)
        .then(function () {
          $scope.model.applications.push(NOTIFICATION_TYPE_OPTIONS.ALL)
        })
    }

    init()
  }
})()
